import { PortfolioNft, SUPPORTED_NETWORKS } from "@cede/types";

const providers: Record<string, (nft: PortfolioNft) => string> = {
  [SUPPORTED_NETWORKS.ETH]: (nft: PortfolioNft) => `https://etherscan.io/address/${nft.tokenAddress}`,
};

export function getBlockExplorerNftUrl(nft: PortfolioNft) {
  const provider = providers[nft.network];

  if (provider) return provider(nft);

  return null;
}
